import styled from "styled-components";

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
`;

export const ModalContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 32rem;
  background-color: #ffffff;
  border-radius: 1rem;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  max-height: 90vh;
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid #F3F4F6;
  flex-shrink: 0;
`;

export const ModalTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 700;
  color: #111827;
  margin: 0;
  line-height: 1.2;
  letter-spacing: -0.025em;
`;

export const ModalCloseButton = styled.button`
  padding: 0.5rem;
  border-radius: 9999px;
  border: none;
  background-color: transparent;
  color: #9CA3AF;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;

  &:hover {
    background-color: #F3F4F6;
    color: #4B5563;
  }
`;

export const ModalBody = styled.div`
  overflow-y: auto;
  padding: 1.5rem;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const TemplateSearchWrapper = styled.div`
  position: relative;
  flex-shrink: 0;

  .search-icon {
    position: absolute;
    left: 0.85rem;
    top: 50%;
    transform: translateY(-50%);
    color: #9CA3AF;
    pointer-events: none;
  }
`;

export const TemplateSearchInput = styled.input`
  width: 100%;
  padding: 0.6rem 0.85rem 0.6rem 2.5rem;
  background-color: #F9FAFB;
  border: 1px solid #E5E7EB;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  color: #111827;
  transition: all 0.2s;

  &::placeholder {
    color: #9CA3AF;
  }

  &:focus {
    outline: none;
    border-color: #021526;
    background-color: #ffffff;
    box-shadow: 0 0 0 3px rgba(2, 21, 38, 0.1);
  }
`;

export const TemplateListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  max-height: 240px;
  overflow-y: auto;
  padding-right: 0.25rem;
  flex-shrink: 0;
`;

export const ModalFooter = styled.div`
  padding: 1.25rem 1.5rem;
  background-color: rgba(249, 250, 251, 0.5);
  border-top: 1px solid #F3F4F6;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.75rem;
  flex-shrink: 0;
  border-radius: 0 0 1rem 1rem;
`;

export const TemplateCard = styled.button<{ $selected?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  text-align: left;
  padding: 1rem;
  border-radius: 0.75rem;
  border: 1px solid ${(props) => (props.$selected ? "#021526" : "#E5E7EB")};
  background-color: ${(props) => (props.$selected ? "#F9FAFB" : "#ffffff")};
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    border-color: #021526;
  }
`;

export const TemplateCardName = styled.span`
  font-size: 0.9375rem;
  font-weight: 600;
  color: #111827;
`;

export const TemplateCardIntro = styled.span`
  font-size: 0.8125rem;
  color: #6B7280;
  line-height: 1.4;
`;

export const ModalFormField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`;

export const ModalLabel = styled.label`
  font-size: 0.8125rem;
  font-weight: 600;
  color: #111827;
`;

export const ModalInput = styled.input`
  width: 100%;
  padding: 0.65rem 0.85rem;
  background-color: #F9FAFB;
  border: 1px solid #E5E7EB;
  border-radius: 0.5rem;
  font-size: 0.9375rem;
  color: #111827;
  transition: all 0.2s;

  &::placeholder {
    color: #9CA3AF;
  }

  &:focus {
    outline: none;
    border-color: #021526;
    background-color: #ffffff;
  }
`;
